<h1 mat-dialog-title>{{ data.title }}</h1>
<mat-dialog-content>
  <div style="color:green" [innerHTML]="data.text"></div><br>
  <div *ngIf="data.showPrompt">
    <mat-label> Set custom rental? </mat-label><input type="checkbox" name="chkCustomRental" value="{{ data.isCustomRental }}" [checked]="data.isCustomRental" (change)="data.isCustomRental = !data.isCustomRental" /><br>
    <br>  
    <div *ngIf="data.isCustomRental">
      <mat-label>£</mat-label>
      <input type="number" name="txtRentalAmount" value="{{ data.rentalAmount }}" min="0" max="995" step="5" size="5" (change)="data.rentalAmount = $event.target.value">
      <span> pw</span>
    </div>
  </div>  
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button *ngIf="data.showCancel" class="btn btn-light" mat-button mat-dialog-close>Cancel</button>
  <button class="btn btn-primary" mat-button [mat-dialog-close]="data" cdkFocusInitial>Ok</button>
</mat-dialog-actions>
